module.exports = __webpack_public_path__ + "media/get_assistance_app.5082ac65.mp4";